
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/car-maintenance",
      function () {
        return require("private-next-pages/guides/car-maintenance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/car-maintenance"])
      });
    }
  